import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import { useToast } from '../context/ToastContext';
import { authService } from '../api/axios';
import './AuthForm.css';

const ForcePasswordChange = () => {
  const { addToast } = useToast();
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { passwordChanged } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (newPassword !== confirmPassword) {
      setError("Passwords do not match.");
      return;
    }
    if (newPassword.length < 8) {
      setError("Password must be at least 8 characters long.");
      return;
    }

    setError('');
    setIsLoading(true);

    try {
      // The bearer token is attached by the authService interceptor — nothing
      // to read or log here.
      await authService.post('/auth/force-password-change', { newPassword });
      passwordChanged();
      // Toast renders above the router, so it survives this navigation.
      addToast('Password changed. Please log in again.', 'success', 5000);
      navigate('/login');
    } catch (err) {
      // Status and message only: err.config.headers carries the Authorization
      // header, so logging the whole error puts the JWT in the console.
      console.error('Force password change failed:', err.response?.status, err.response?.data);
      setError(err.response?.data || "Failed to change password.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-form-panel">
        <div className="auth-form-container">
          <h2>Change Your Password</h2>
          <p className="form-subtitle">Please set a new password to continue.</p>
          <form onSubmit={handleSubmit}>
            <div className="input-group">
              <input
                type="password"
                className="auth-input"
                placeholder="New Password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                required
              />
            </div>
            <div className="input-group">
              <input
                type="password"
                className="auth-input"
                placeholder="Confirm New Password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
              />
            </div>
            {error && <p style={{ color: 'red', textAlign: 'center' }}>{error}</p>}
            <button type="submit" className="auth-button-primary" disabled={isLoading}>
              {isLoading ? 'Changing...' : 'Change Password'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ForcePasswordChange;